const GIFT_PRODUCT_ID = 9004581290228;
const GIFT_VARIANT_ID = 46402690777332;

// Fetch cart
async function getCart() {
  const res = await fetch('/cart.js');
  return await res.json();
}

async function addGift(variantId, quantity = 1) {
  console.log('[Gift Sync] Adding product to cart:', variantId, 'x', quantity);

  const formData = {
    items: [{
      id: variantId,
      quantity
    }]
  };

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(formData)
  });

  if (!res.ok) {
    const error = await res.json();
    console.error('[Gift Sync] Failed to add gift:', error);
    throw new Error('Add to cart failed');
  }

  console.log('[Gift Sync] Gift added successfully');
}




function removeGift(lineIndex) {
  console.log('[Gift Sync] Removing gift via /cart/change.js');
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: lineIndex, quantity: 0 })
  }).then(() => {
    return updateCartSections();
  });
}

function updateCartSections() {
  return fetch(`${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`)
    .then(res => res.json())
    .then(data => {
      if (!data) return;

      const sectionMap = {
        'cart-items': '[data-cart-items]',
        'cart-footer': '[data-cart-footer]',
        'cart-item-count': '[x-text="$store.cart_count.countWithText"]',
        'cart-live-region': '#cart-live-region-text'
      };

      for (const [section, html] of Object.entries(data)) {
        const selector = sectionMap[section];
        const container = document.querySelector(selector);

        if (!container) {
          console.warn(`[Gift Sync] Missing element for section: ${section}`);
          continue;
        }

        const temp = document.createElement('div');
        temp.innerHTML = html;

        const inner = temp.querySelector('[data-cart-items], [data-cart-footer], [x-text], #cart-live-region-text');
        if (inner) {
          container.innerHTML = inner.innerHTML;
          console.log(`[Gift Sync] Updated: ${section}`);
        } else {
          console.warn(`[Gift Sync] Could not extract inner content for ${section}`);
        }
      }

      // Re-init Alpine if needed
      if (window.Alpine?.initTree) {
        window.Alpine.initTree(document.querySelector('[data-cart-drawer]') || document.body);
        console.log('[Gift Sync] Alpine rehydrated');
      }
    });
}



// Core sync logic
async function syncFreeGift() {
  const giftVariantId = 46402690777332;

  try {
    const cart = await getCart();
    console.log('[Gift Sync] Cart items:', cart.items);

    // Count non-gift items
    const nonGiftItems = cart.items.filter(item => item.variant_id !== giftVariantId);
    const nonGiftCount = nonGiftItems.reduce((sum, item) => sum + item.quantity, 0);

    // Count gift items
    const giftItems = cart.items.filter(item => item.variant_id === giftVariantId);
    const giftCount = giftItems.reduce((sum, item) => sum + item.quantity, 0);

    console.log(`[Gift Sync] Non-gift items: ${nonGiftCount}, Gift items: ${giftCount}`);

    if (giftCount > nonGiftCount) {
      // Remove excess gifts
      for (const giftItem of giftItems) {
        const excess = giftCount - nonGiftCount;
        const removeQty = Math.min(excess, giftItem.quantity);
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftItem.key, quantity: giftItem.quantity - removeQty })
        });
        console.log(`[Gift Sync] Removed ${removeQty} gift(s)`);
        break; // Only need one removal loop
      }
    } else if (giftCount < nonGiftCount) {
      // Add missing gifts
      const toAdd = nonGiftCount - giftCount;
      await addGift(giftVariantId, toAdd);
    }

    await updateCartSections();

    // ✅ Update Alpine cart count
    const refreshedCart = await getCart();
    if (window.Alpine?.store('cart_count')) {
      Alpine.store('cart_count').count = refreshedCart.item_count;
      console.log('[Gift Sync] Updated cart count:', refreshedCart.item_count);
    }

  } catch (error) {
    console.error('[Gift Sync] Error:', error);
  }
}


document.addEventListener('DOMContentLoaded', () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const delay = isMobile ? 900 : 500;

  const delayedSync = () => {
    console.log('[Gift Sync] Delayed sync triggered');
    setTimeout(() => {
      syncFreeGift();
    }, delay);
  };

  // Initial sync on page load
  syncFreeGift();

  // Watch for standard Shopify cart quantity changes
  document.body.addEventListener('shapes:cart:cartqtychange', () => {
    console.log('[Gift Sync] cartqtychange event');
    delayedSync();
  });

  // Catch form submits (product forms, upsells, quick buys)
  document.body.addEventListener('submit', (e) => {
    if (e.target.matches('form[action^="/cart/add"]')) {
      console.log('[Gift Sync] Form submitted');
      delayedSync();
    }
  });

  // Catch any add-to-cart buttons clicked directly
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('.add-to-cart-btn, [name="add"]');
    if (btn) {
      console.log('[Gift Sync] Add button clicked');
      delayedSync();
    }
  });

  // Mobile-only: watch for visibility/navigation restoration
  window.addEventListener('pageshow', () => {
    console.log('[Gift Sync] pageshow (mobile navigation)');
    delayedSync();
  });
});

document.addEventListener('submit', (e) => {
  const form = e.target.closest('form.quick-buy-product-form');
  if (form) {
    console.log('[Gift Sync] Quick buy upsell form submitted');

    setTimeout(() => {
      syncFreeGift();
    }, 700); // Give Shopify a little extra time to update cart
  }
});
